import { useHistory } from 'react-router-dom';
import { Typography, Button, useMediaQuery, Box } from '@mui/material';
import { useAccount } from '../../contexts/Account';

const useStyles = ({ isSM }) => ({
  content: {
    padding: isSM ? '20px' : '16px 0px',
  },
  text: {
    textAlign: 'left',
    mx: '0px',
  },
  textCompanyName: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    maxWidth: '100%',
    alignItems: 'center',
  },
  listItem: {
    marginBottom: 12,
    fontSize: 16,
  },
});

export default function step4() {
  const history = useHistory();
  const { accountDetails } = useAccount();
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles({ isSM });

  return (
    <Box sx={classes.content}>
      <Box style={classes.textCompanyName}>
        {accountDetails.image && accountDetails.image.id && (
          <img
            alt="Company Image"
            style={{
              width: '100px',
              borderRadius: '146px',
            }}
            src={`${process.env.REACT_APP_IMAGES_URL}${accountDetails.image.id}`}
          />
        )}
        <Typography
          variant="caption"
          sx={{
            fontSize: isXS ? '24px' :  '28px',
            fontWeight: 700,
            letterSpacing: '-0.43px',
            textAlign: 'center',
            my: '12px',
          }}
        >
          The {accountDetails.displayName || accountDetails.companyName}{' '}
          Advisory Board is ready to launch!
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontStyle: 'italic',
            fontSize: '16px',
            fontWeight: 300,
            lineHeight: '24px',
            letterSpacing: '-0.43px',
            color: '#646D7A',
            marginBottom: '18px',
            textAlign: 'left',
          }}
        >
          A few final tips…
        </Typography>
      </Box>
      <Box sx={classes.text}>
        <ol
          style={{
            listStyleType: 'decimal',
            fontSize: 13,
            paddingLeft: 20,
            color: '#232B35',
            margin: '0',
          }}
        >
          <li style={classes.listItem}>
            Invite lots of different types of people to be on your advisory
            board.
          </li>
          <li style={classes.listItem}>
            The days of a 5 person advisory board are long gone, the more people
            on your board, the more ideas and advocates for you.{' '}
            <strong>
              The first 100 members of your advisory board are free. Once you
              surpass that, you can simply upgrade your account to keep growing
              your board!
            </strong>
          </li>
          <li style={classes.listItem}>
            Post an update once a month for your advisory board, this will be
            shared with all your advisors for them to respond in your digital
            boardroom.
          </li>
          <li style={classes.listItem}>
            You'll be amazed how willing people are to help with ideas,
            introductions and so much more…when they're on your advisory board.
          </li>
        </ol>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: '28px',
        }}
      >
        <Button
          id="company-onboarding-step-4"
          variant="contained"
          color="primary"
          onClick={() => {
            history.push('/company/onboarding/step5');
          }}
          className="getStartedButton"
          sx={{
            backgroundColor: '#3578F4',
            paddingTop: '15px',
            paddingBottom: '15px',
            textTransform: 'none',
            fontWeight: '700',
            fontSize: '15px',
            width: '260px',
            height: '44px',
            borderRadius: '30px',
          }}
        >
          Launch Advisory Board
        </Button>
      </Box>
    </Box>
  );
}
